<mh-edit-user-profile [user]="user" [viewType]="'new'" (waitingState)="setWaiting($event)" (closeModal)="setModal($event)"></mh-edit-user-profile>


